import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss']
})
export class ParagraphComponent implements OnInit {

  constructor() { }
  @Input() label;
  @Input() label_class;
  @Input() label_css;
  @Input() control_class;
  @Input() control_css;
  @Input() label_width;
  @Input() control_width;
  @Input() style;
  ngOnInit() {

  }

}
